import { Input } from "antd";
import { useEffect, useRef } from "react";

const ThemeInput = ({
  label,
  placeholder,
  value,
  labelPrimary,
  textMd,
  className,
  password,
  onChange,
  name,
  disabled,
  onKeyDown,
  type,
  register,
  error,
  setValue,
  icon, 
  ...rest
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (register) {
      register(name, { shouldUnregister: true });
    }
  }, [register, name]);

  return (
    <div className={className}>
      {label && (
        <p
          className={`${labelPrimary ? "text-primary" : ""} ${
            textMd ? "font-medium" : "font-semibold"
          } mb-1`}
        >
          {label}
        </p>
      )}
      {password ? (
        <Input.Password
          ref={inputRef}
          onKeyDown={onKeyDown}
          name={name}
          placeholder={placeholder}
          value={value}
          className={`h-10 font-medium ${error ? "border-red-500" : ""}`}
          onChange={(e) => {
            onChange && onChange(e);
            if (setValue) {
              setValue(name, e.target.value);
            }
          }}
          disabled={disabled}
          {...rest}
        />
      ) : (
        <Input
          type={type || "text"}
          ref={inputRef}
          onKeyDown={onKeyDown}
          name={name}
          placeholder={placeholder}
          value={value}
          className={`h-10 font-medium ${error ? "border-red-500" : ""}`}
          prefix={icon} 
          onChange={(e) => {
            onChange && onChange(e);
            if (setValue) {
              setValue(name, e.target.value);
            }
          }}
          disabled={disabled}
          {...rest}
        />
      )}
    </div>
  );
};

export default ThemeInput;
